import { MercureContext } from "@app/providers/MercureProvider";
import { useContext } from "react";

export const useMercureContext = () => {
  const context = useContext(MercureContext);
  // Return null gracefully instead of throwing
  // This handles the case when user logs out and context becomes null
  // Components should check for null before using the client
  return context;
};

export default useMercureContext;
